import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Modal from '../../common/Modal';
import EmergencyPerson from '../../../images/EmergencyPerson.svg';
import EmergencyInfo from '../../../images/EmergencyInfo.svg';
import Plus from '../../../images/Plus.svg';
import { FaChevronRight } from 'react-icons/fa';
import ContactCard from './ContactCard';
import {
  addEmergencyContact,
  deleteEmergencyContact,
  fetchActiveContact,
  fetchEmergencyContacts,
  fetchRelativeId,
  getActiveContact,
  markContactsInactive,
  setContactActive,
} from '../../../services';
import EmergencyContactMenu from './EmergencyContactMenu';
import { useHistory } from 'react-router-dom';
import { getConsultationSummary, showError } from '../../../actions';
import LoadingComponent from '../../../components/common/LoadingComponent';
import { useDispatch } from 'react-redux';
import { FlyInTransition } from '../../../components/transitions/transitions';

const LoadingContainer = styled.div`
  width: 441px;
  height: 560px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;

  @media (max-width: 425px) {
    width: 370px;
  }
`;

const Title = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: #000000;
  margin-top: 20px;
  margin-left: 20px;

  @media (max-width: 425px) {
    font-size: 11px;
  }
`;

const AddContainer = styled.div`
  display: flex;
  margin-top: 24px;
  margin-left: 20px;
`;

const PlusImg = styled.img`
  cursor: pointer;
`;

const AddText = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  display: flex;
  align-items: center;
  letter-spacing: 0.25px;
  color: #0f0b28;
  margin-left: 10px;
`;

const WarningTextContainer = styled.div`
  height: 28px;
  width: 302px;
  margin-top: 10px;
  margin-left: 53px;
`;

const WarningText = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 140%;
  display: flex;
  align-items: center;
  letter-spacing: 0.25px;
  color: #767787;
`;

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f3f6;
  padding: 16px 20px;
`;

const HeadText = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #0f0b28;
`;

const HeadImg = styled.img``;

const HeadSkipContainer = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const HeadSkip = styled.p`
  font-family: 'var(--font-secondary)';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #585969;
`;

const DescContainer = styled.div`
  padding: 16px 10px;
  margin-top: 16px;
  display: flex;
  align-self: center;
  gap: 10px;
  background: rgba(207, 200, 255, 0.32);
  border-radius: 8px;
`;

const DescText = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  letter-spacing: 0.25px;
  color: #585969;
`;

const DescImg = styled.img`
  height: 12px;
  width: 12px;
`;

const Line = styled.div`
  border-bottom: 1px solid #f0f3f6;
  margin-top: 30px;
`;

const ConsentContainer = styled.div`
  display: flex;
  padding: 16px 20px;
  align-items: start
  gap: 10px;
`;

const ConsentText = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  color: #0f0b28;
`;

const ConsentInput = styled.input``;

const SubmitY = styled.button`
  display: flex;
  padding: 14px 160px;
  color: #ffffff;
  text-align: center;
  gap: 10px;
  width: 90%;
  background: var(--primary-button);
  font-family: 'var(--font-secondary)';
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  font-size: 14px;
  border-radius: 12px;
  margin-left: 25px;
  margin-top: 20px;
`;

const SubmitN = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 160px;
  color: rgba(0, 0, 0, 0.2);
  text-align: center;
  gap: 10px;
  width: 90%;
  background: rgba(228, 228, 228, 0.5);
  cursor: default;
  font-family: 'var(--font-secondary)';
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  font-size: 14px;
  border-radius: 12px;
  margin-left: 25px;
  margin-top: 20px;
`;

const Contacts = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [active, setActive] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [consent, setConsent] = useState(false);
  const [activeContact, setActiveContact] = useState(null);
  const [close, setClose] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [toEdit, setToEdit] = useState();
  const [toAdd, setToAdd] = useState(false);
  const [addContact, setAddContact] = useState(false);
  const [valueEdit, setValueEdit] = useState(null);

  const history = useHistory();

  const dispatch = useDispatch();

  useEffect(() => {
    const getAllInformation = async () => {
      try {
        const consultationDetails = await fetchRelativeId(props);
        const contactsData = await fetchEmergencyContacts(
          props,
          consultationDetails.relativeId
        );
        const activeContact = await fetchActiveContact(props);
        if (contactsData.message === 'success')
          setContacts(contactsData.contactInfo);
        if (activeContact.message === 'success')
          setActiveContact(activeContact.contactId);
        setIsLoading(false);
      } catch (err) {
        showError(err.message);
      }
    };
    getAllInformation();
    if (
      props.information.location.state &&
      !props.information.location.state.scheduledConsultationId
    ) {
      dispatch(getConsultationSummary());
    }
  }, []);

  const handleActive = (data) => {
    const markActive = () => {
      setContactActive(data)
        .then(async (res) => {
          if (res.message === 'success') {
            const activeContact = await fetchActiveContact(props);
            if (activeContact.message === 'success')
              setActiveContact(activeContact.contactId);
          }
        })
        .catch((err) => {
          showError(err.message);
        });
    };
    markActive();
  };

  const handleEdit = (data, value) => {
    console.log(value, 'check val');
    setIsEdit(true);
    setToEdit(data);
    setValueEdit(value);
  };

  const handleDelete = (data) => {
    const deleteContact = async () => {
      try {
        setIsLoading(true);
        const consultationDetails = await fetchRelativeId(props);
        const removeContact = await deleteEmergencyContact(
          data,
          consultationDetails.relativeId
        );
        if (removeContact.message === 'success') {
          const contactsData = await fetchEmergencyContacts(
            props,
            consultationDetails.relativeId
          );
          if (contactsData.message === 'success')
            setContacts(contactsData.contactInfo);
        }
        setIsLoading(false);
      } catch (err) {
        showError(err.message);
      }
    };
    deleteContact();
  };

  const handleSkip = () => {
    markContactsInactive(props)
      .then((res) => {
        if (res.message === 'success') {
          props.hideModal();
        }
      })
      .catch((err) => {
        showError(err.message);
      });
  };

  // contacts.pop();

  return contacts && contacts.length && !isEdit && !toAdd ? (
    <Modal>
      <div className="modalContainer">
        <FlyInTransition in={true} mountOnEnter unmountOnExit appear>
          {isLoading ? (
            <LoadingComponent />
          ) : (
            <div className="modalBody">
              <MenuContainer
                style={
                  contacts.length > 2
                    ? { height: '700px' }
                    : contacts.length > 1
                    ? { height: '600px' }
                    : { height: '520px' }
                }
              >
                <Head>
                  <HeadSkipContainer>
                    <HeadImg src={EmergencyPerson}></HeadImg>
                    <HeadText>Emergency Contact</HeadText>
                  </HeadSkipContainer>
                  <HeadSkipContainer onClick={() => handleSkip()}>
                    <HeadSkip>Skip</HeadSkip>
                    <FaChevronRight
                      style={{
                        height: '8px',
                        width: '7.6px',
                      }}
                    />
                  </HeadSkipContainer>
                </Head>
                <DescContainer>
                  <DescImg src={EmergencyInfo} />
                  <DescText>
                    Emergency contact will only be used in case of any serious
                    cases.
                  </DescText>
                </DescContainer>
                <div className="flex flex-col justify-center h-full">
                  <Title>Choose an Emergency Contact -</Title>
                  <div className="flex items-start justify-center mt-10px">
                    {contacts.map((contact, id) => {
                      return (
                        <ContactCard
                          information={props}
                          handleActive={handleActive}
                          handleDelete={handleDelete}
                          handleEdit={handleEdit}
                          contact={contact}
                          activeContact={activeContact}
                          key={id}
                        />
                      );
                    })}
                  </div>
                </div>
                {contacts && contacts.length >= 3 ? (
                  <>
                    <AddContainer>
                      <PlusImg
                        src={Plus}
                        style={{ opacity: '0.5', cursor: 'default' }}
                      />
                      <AddText style={{ color: '#585969', opacity: '0.5' }}>
                        Add New Contact
                      </AddText>
                    </AddContainer>
                    <WarningTextContainer>
                      <WarningText>
                        You can only add upto 3 Emergency Contacts. Delete
                        another contact to add new.
                      </WarningText>
                    </WarningTextContainer>
                  </>
                ) : (
                  <AddContainer>
                    <PlusImg src={Plus} onClick={() => setToAdd(true)} />
                    <AddText>Add New Contact</AddText>
                  </AddContainer>
                )}
                <Line
                  style={
                    contacts && contacts.length >= 3
                      ? { marginTop: '20px' }
                      : { marginTop: '55px' }
                  }
                />
                <ConsentContainer>
                  <ConsentInput
                    type="checkbox"
                    onClick={() => setConsent((prev) => !prev)}
                  />
                  <ConsentText>
                    I hereby authorize the doctor to contact the emergency
                    contact person in case of any emergency and to share my
                    and/or my dependant’s personal details related to this
                    consultation if required.
                  </ConsentText>
                </ConsentContainer>
                <Line style={{ marginTop: '18px' }} />
                {consent && activeContact ? (
                  <SubmitY onClick={() => props.hideModal()}>Submit</SubmitY>
                ) : (
                  <SubmitN>Submit</SubmitN>
                )}
              </MenuContainer>
            </div>
          )}
        </FlyInTransition>
      </div>
    </Modal>
  ) : (
    <EmergencyContactMenu
      information={props}
      length={contacts.length}
      isEdit={isEdit}
      toAdd={toAdd}
      toEdit={toEdit}
      valueEdit={valueEdit}
      loading={isLoading}
    />
  );
};

export default Contacts;
